"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[901],{

/***/ 8901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ./src/snippets/index.js + 293 modules
var snippets = __webpack_require__(596);
;// CONCATENATED MODULE: ./src/templates/account/activate.jsx








function Activate(param) {
    var params = param.params;
    var ref;
    var ref1 = (0,dist.useCustomerActivate)(), activateAccount = ref1.activateAccount, errors = ref1.errors, finished = ref1.finished, reset = ref1.reset, resetTimer = ref1.resetTimer, setErrors = ref1.setErrors, started = ref1.started, success = ref1.success;
    var router = (0,dist.useRouter)();
    var settings = (0,dist.useSettings)();
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.activate), heading = ref2.heading, subtext = ref2.subtext;
    var customerId = params.customerId, activationToken = params.activationToken;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Account Activated" : "Failed";
        }
        return started ? "Activating Account" : "Activate Account";
    }, [
        started,
        success,
        finished
    ]);
    var handleActivateAccount = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _target, password, passwordConfirm;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (started) return [
                            2
                        ];
                        _target = event.target, password = _target.password, passwordConfirm = _target.passwordConfirm;
                        if (password.value !== passwordConfirm.value) {
                            setErrors([
                                "Passwords do not match. Please try again."
                            ]);
                            if (finished) {
                                resetTimer.current = setTimeout(function() {
                                    if (reset) reset();
                                    clearTimeout(resetTimer.current);
                                }, 3000);
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            activateAccount({
                                password: password.value,
                                customerId: customerId,
                                activationToken: activationToken
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        activationToken,
        customerId,
        finished,
        reset,
        started
    ]);
    (0,react.useEffect)(function() {
        if (finished && success) {
            setTimeout(function() {
                return router.push("/account/login");
            }, 3000);
        }
    }, [
        finished,
        success
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        heading,
                         true ? " | ".concat("Storefront Starter") : 0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained py-contained flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto flex w-full max-w-[28rem] flex-col items-center rounded border border-border px-3 py-6 md:px-6 md:py-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-title-h3 text-center",
                                    children: heading
                                }),
                                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[20rem] text-center text-sm",
                                    children: subtext
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "mx-auto flex w-full max-w-[25rem] flex-col gap-4",
                            onSubmit: handleActivateAccount,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "password",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-title-h6 block pb-1 pl-5",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "input-text",
                                            name: "password",
                                            placeholder: "••••••••",
                                            required: true,
                                            type: "password"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "passwordConfirm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-title-h6 block pb-1 pl-5",
                                            children: "Confirm Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "input-text",
                                            name: "passwordConfirm",
                                            placeholder: "••••••••",
                                            required: true,
                                            type: "password"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Submit to activate account",
                                    className: "btn-primary mt-3 min-w-[10rem] self-center ".concat(started ? "cursor-default" : ""),
                                    type: "submit",
                                    children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                                        width: "20"
                                    }) : buttonText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": "Go back to login page",
                            className: "text-underline mt-4 text-center text-sm font-bold",
                            href: "/account/login",
                            children: "Cancel"
                        }),
                        (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "mt-4 flex flex-col items-center gap-1",
                            children: errors.map(function(error, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "text-center text-sm text-red-500",
                                    children: error
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
Activate.displayName = "Activate";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
;// CONCATENATED MODULE: ./src/layouts/AccountLayout.jsx







function AccountLayout(param) {
    var children = param.children;
    var ref, ref1, ref2;
    var asPath = (0,router.useRouter)().asPath;
    var customer = (0,dist.useCustomer)();
    var customerLogout = (0,dist.useCustomerLogout)().customerLogout;
    var settings = (0,dist.useSettings)();
    var ref3 = (0,react.useState)(false), menuOpen = ref3[0], setMenuOpen = ref3[1];
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.menu), helpHeading = ref4.helpHeading, helpItems = ref4.helpItems, menuItems = ref4.menuItems;
    var activeMenuItem = (0,react.useMemo)(function() {
        return menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(param) {
            var link = param.link;
            return asPath.startsWith(link === null || link === void 0 ? void 0 : link.url);
        });
    }, [
        asPath,
        menuItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : (ref1 = activeMenuItem.link) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        activeMenuItem.link.text,
                         true ? " | ".concat("Storefront Starter") : 0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained py-contained",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto grid w-full max-w-[80rem] grid-cols-1 gap-8 md:grid-cols-[12rem_1fr] lg:grid-cols-[16rem_1fr]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row justify-between gap-6 pb-6 md:flex-col md:justify-start md:border-b md:border-b-border",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-title-h4 md:text-title-h5 lg:text-title-h4 mb-1 break-words",
                                                    children: [
                                                        "Hi",
                                                        (customer === null || customer === void 0 ? void 0 : customer.firstName) ? ", ".concat(customer.firstName) : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "break-words text-xs",
                                                    children: customer === null || customer === void 0 ? void 0 : customer.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                "aria-label": "Sign out",
                                                className: "text-main-underline text-nav bg-[linear-gradient(var(--primary),var(--primary))] font-normal",
                                                onClick: customerLogout,
                                                type: "button",
                                                children: "Sign Out"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: "hidden border-b border-b-border py-6 md:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col items-start md:gap-4 lg:gap-6",
                                        children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(param, index) {
                                            var link = param.link;
                                            return (link === null || link === void 0 ? void 0 : link.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                                    "aria-label": link.text,
                                                    href: link.url,
                                                    newTab: link.newTab,
                                                    type: link.type,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-title-h5 md:text-title-h4 lg:text-title-h3 hover-text-underline",
                                                        children: link.text
                                                    })
                                                })
                                            }, index) : null;
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative w-full md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            "aria-label": "Open account menu",
                                            className: "flex h-14 w-full items-center justify-between gap-4 rounded-full border border-gray px-5 text-base",
                                            onClick: function() {
                                                return setMenuOpen(!menuOpen);
                                            },
                                            type: "button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: activeMenuItem === null || activeMenuItem === void 0 ? void 0 : (ref2 = activeMenuItem.link) === null || ref2 === void 0 ? void 0 : ref2.text
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                    className: "w-4 text-text ".concat(menuOpen ? "rotate-180" : ""),
                                                    src: "/svgs/chevron-down.svg#chevron-down",
                                                    title: "Chevron Down",
                                                    viewBox: "0 0 24 24"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                            className: "absolute top-[calc(100%+0.5rem)] left-0 z-10 w-full rounded-[0.5rem] border border-gray bg-background text-base transition duration-100 ".concat(menuOpen ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none -translate-y-1 opacity-0"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "scrollbar-hide flex max-h-[18rem] flex-col gap-0 overflow-y-auto py-2",
                                                children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(param, index) {
                                                    var link = param.link;
                                                    var ref;
                                                    var isActive = (link === null || link === void 0 ? void 0 : link.url) === (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : (ref = activeMenuItem.link) === null || ref === void 0 ? void 0 : ref.url);
                                                    return (link === null || link === void 0 ? void 0 : link.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                                            "aria-hidden": menuOpen ? "true" : "false",
                                                            "aria-label": link.text,
                                                            "aria-selected": isActive ? "true" : "false",
                                                            className: "w-full py-1.5 px-5 transition md:hover:bg-offWhite ".concat(isActive ? "bg-lightGray" : "bg-transparent"),
                                                            href: link.url,
                                                            newTab: link.newTab,
                                                            tabIndex: menuOpen ? "0" : "-1",
                                                            type: link.type,
                                                            children: link.text
                                                        })
                                                    }, index) : null;
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "hidden flex-col items-start gap-2 py-6 md:flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-base font-normal",
                                            children: helpHeading
                                        }),
                                        helpItems === null || helpItems === void 0 ? void 0 : helpItems.map(function(param, index) {
                                            var link = param.link;
                                            return (link === null || link === void 0 ? void 0 : link.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                                    "aria-label": link.text,
                                                    className: "break-words text-xs",
                                                    href: link.url,
                                                    type: link.type,
                                                    children: link.text
                                                })
                                            }, index) : null;
                                        })
                                    ]
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        ]
    });
}
AccountLayout.displayName = "AccountLayout";
/* harmony default export */ var layouts_AccountLayout = (AccountLayout);

;// CONCATENATED MODULE: ./src/templates/account/address-book/AddressBookItem.jsx





function AddressBookItem(param) {
    var address = param.address, defaultAddress = param.defaultAddress, initialAddress = param.initialAddress, setInitialAddress = param.setInitialAddress, setIsCreateAddress = param.setIsCreateAddress;
    var ref;
    var deleteAddress = (0,dist.useCustomerDeleteAddress)().deleteAddress;
    var ref1 = (0,react.useState)(false), isDeleteConfirm = ref1[0], setIsDeleteConfirm = ref1[1];
    var address1 = address.address1, address2 = address.address2, city = address.city, company = address.company, country = address.country, id = address.id, name = address.name, phone = address.phone, provinceCode = address.provinceCode, zip = address.zip;
    var isDefaultAddress = (defaultAddress === null || defaultAddress === void 0 ? void 0 : (ref = defaultAddress.id) === null || ref === void 0 ? void 0 : ref.split("?")[0]) === id.split("?")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-full flex-col justify-between gap-y-6 gap-x-4 rounded border border-border p-6 xs:flex-row md:flex-col lg:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-title-h5 mb-2",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1.5 text-sm",
                        children: [
                            company && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: company
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address1
                            }),
                            address2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "".concat(city, ", ").concat(provinceCode, " ").concat(zip)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: country
                            }),
                            phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: phone
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between gap-6 xs:flex-col md:flex-row lg:flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Edit address",
                                className: "text-nav text-main-underline font-normal",
                                onClick: function() {
                                    setInitialAddress(address);
                                    setIsCreateAddress(false);
                                    window.scrollTo({
                                        top: 0,
                                        behavior: "smooth"
                                    });
                                },
                                type: "button",
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Delete address",
                                className: "text-nav text-main-underline font-normal text-red-500",
                                onClick: function() {
                                    return setIsDeleteConfirm(true);
                                },
                                type: "button",
                                children: "Delete"
                            })
                        ]
                    }),
                    isDefaultAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-nav text-right text-gray",
                        children: "Default"
                    })
                ]
            }),
            isDeleteConfirm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-0 left-0 flex h-full w-full flex-col items-center justify-center gap-4 bg-[rgba(255,255,255,0.9)] p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center text-sm",
                        children: "Are you sure you want to delete this address?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Delete address",
                                className: "text-nav text-main-underline font-normal",
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    deleteAddress({
                                                        id: id
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                setIsDeleteConfirm(false);
                                                if (id === (initialAddress === null || initialAddress === void 0 ? void 0 : initialAddress.id)) setInitialAddress(null);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                type: "button",
                                children: "Delete"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Cancel",
                                className: "text-nav text-main-underline font-normal",
                                onClick: function() {
                                    return setIsDeleteConfirm(false);
                                },
                                type: "button",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
AddressBookItem.displayName = "AddressBookItem";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ./src/hooks/index.js + 34 modules
var hooks = __webpack_require__(9894);
;// CONCATENATED MODULE: ./src/templates/account/address-book/AddressForm.jsx






var blankForm = {
    firstName: "",
    lastName: "",
    company: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    country: "",
    zip: "",
    phone: ""
};
function AddressForm(param) {
    var buttonText = param.buttonText, closeForm = param.closeForm, defaultAddress = param.defaultAddress, errors = param.errors, initialAddress = param.initialAddress, _onSubmit = param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, started = param.started, title = param.title;
    var ref = (0,hooks/* useCountriesList */.oe)({
        firstCountries: [
            "United States",
            "Canada",
            "United Kingdom",
            "Australia"
        ]
    }), countryNames = ref.countryNames, countryNamesData = ref.countryNamesData;
    var ref1 = (0,react.useState)(false), isDefault = ref1[0], setIsDefault = ref1[1];
    var ref2 = (0,react.useState)(blankForm), form = ref2[0], setForm = ref2[1];
    var countries = (0,react.useMemo)(function() {
        return countryNames.map(function(name) {
            return {
                label: name,
                value: name
            };
        });
    }, [
        countryNames
    ]);
    var provinces = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref = countryNamesData === null || countryNamesData === void 0 ? void 0 : countryNamesData.find(function(param) {
            var countryName = param.countryName;
            return countryName === form.country;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.regions) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
            var name = param.name;
            return {
                label: name,
                value: name
            };
        });
    }, [
        form.country,
        countryNamesData === null || countryNamesData === void 0 ? void 0 : countryNamesData.length
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!initialAddress) {
            setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blankForm), {
                country: "United States"
            }));
            setIsDefault(false);
            return;
        }
        setForm({
            firstName: initialAddress.firstName || "",
            lastName: initialAddress.lastName || "",
            company: initialAddress.company || "",
            address1: initialAddress.address1 || "",
            address2: initialAddress.address2 || "",
            city: initialAddress.city || "",
            province: initialAddress.province || "",
            country: initialAddress.country || "",
            zip: initialAddress.zip || "",
            phone: initialAddress.phone || ""
        });
        setIsDefault((defaultAddress === null || defaultAddress === void 0 ? void 0 : (ref = defaultAddress.id) === null || ref === void 0 ? void 0 : ref.split("?")[0]) === ((ref1 = initialAddress.id) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0]));
    }, [
        initialAddress,
        defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded border border-border p-4 sm:p-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 flex items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-title-h5",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Cancel",
                        className: "text-nav text-main-underline font-normal",
                        onClick: closeForm,
                        type: "button",
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "grid grid-cols-2 gap-3",
                onSubmit: function(e) {
                    e.preventDefault();
                    onSubmit({
                        form: form,
                        isDefault: isDefault
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "firstName",
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "First Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "firstName",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        firstName: e.target.value
                                    }));
                                },
                                placeholder: "First Name",
                                required: true,
                                type: "text",
                                value: form.firstName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lastName",
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Last Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "lastName",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        lastName: e.target.value
                                    }));
                                },
                                placeholder: "Last Name",
                                required: true,
                                type: "text",
                                value: form.lastName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "company",
                        className: "col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "company",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        company: e.target.value
                                    }));
                                },
                                placeholder: "Company",
                                type: "text",
                                value: form.company
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "address1",
                        className: "col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Address 1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "address1",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        address1: e.target.value
                                    }));
                                },
                                placeholder: "Address 1",
                                required: true,
                                type: "text",
                                value: form.address1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "address2",
                        className: "col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Address 2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "address2",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        address2: e.target.value
                                    }));
                                },
                                placeholder: "Address 2",
                                type: "text",
                                value: form.address2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "city",
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "City"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "city",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        city: e.target.value
                                    }));
                                },
                                placeholder: "City",
                                required: true,
                                type: "text",
                                value: form.city
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "input-label",
                                children: "State/Province"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Select */.Ph, {
                                onSelect: function(param) {
                                    var value = param.value;
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        province: value
                                    }));
                                },
                                options: provinces || [],
                                placeholder: "Select State/Province",
                                selectedOption: {
                                    label: form.province,
                                    value: form.province
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "zip",
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Zip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "zip",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        zip: e.target.value
                                    }));
                                },
                                placeholder: "Zip",
                                required: true,
                                type: "text",
                                value: form.zip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "input-label",
                                children: "Country"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Select */.Ph, {
                                onSelect: function(param) {
                                    var value = param.value;
                                    setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        country: value,
                                        province: value !== form.country ? "" : form.province
                                    }));
                                },
                                options: countries,
                                placeholder: "Select Country",
                                selectedOption: {
                                    label: form.country,
                                    value: form.country
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "phone",
                        className: "col-span-2 sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Phone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "phone",
                                onChange: function(e) {
                                    return setForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                        phone: e.target.value
                                    }));
                                },
                                placeholder: "Phone",
                                type: "tel",
                                value: form.phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "isDefault",
                        className: "col-span-2 mt-2 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                checked: isDefault,
                                name: "isDefault",
                                onChange: function(e) {
                                    return setIsDefault(e.target.checked);
                                },
                                type: "checkbox"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2 text-sm",
                                children: "Set as default address"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-2 mt-4 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": initialAddress ? "Update Address" : "Add Address",
                            className: "btn-primary w-full min-w-[12rem] md:w-auto ".concat(started ? "cursor-default" : ""),
                            type: "submit",
                            children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                                width: "20"
                            }) : buttonText
                        })
                    }),
                    (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "col-span-2 mt-4 flex flex-col items-center gap-1",
                        children: errors.map(function(error, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-center text-sm text-red-500",
                                children: error
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
AddressForm.displayname = "AddressForm";

;// CONCATENATED MODULE: ./src/templates/account/address-book/CreateAddressForm.jsx






function CreateAddressForm(param) {
    var setIsCreateAddress = param.setIsCreateAddress;
    var ref = (0,dist.useCustomerCreateAddress)(), createAddress = ref.createAddress, errors = ref.errors, finished = ref.finished, reset = ref.reset, resetTimer = ref.resetTimer, setErrors = ref.setErrors, started = ref.started, success = ref.success;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Address Added" : "Failed";
        }
        return started ? "Adding Address" : "Add Address";
    }, [
        started,
        success,
        finished
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm, {
        buttonText: buttonText,
        closeForm: function() {
            return setIsCreateAddress(false);
        },
        errors: errors,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var form, isDefault;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            form = param.form, isDefault = param.isDefault;
                            if (!form.country) {
                                setErrors([
                                    "Missing country"
                                ]);
                                return [
                                    2
                                ];
                            }
                            if (!form.province) {
                                setErrors([
                                    "Missing state/province"
                                ]);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                createAddress({
                                    address: form,
                                    isDefault: isDefault
                                })
                            ];
                        case 1:
                            _state.sent();
                            setIsCreateAddress(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        started: started,
        title: "Add a New Address"
    });
}
CreateAddressForm.displayname = "CreateAddressForm";

;// CONCATENATED MODULE: ./src/templates/account/address-book/EditAddressForm.jsx






function EditAddressForm(param) {
    var defaultAddress = param.defaultAddress, initialAddress = param.initialAddress, setInitialAddress = param.setInitialAddress;
    var ref = (0,dist.useCustomerUpdateAddress)(), errors = ref.errors, finished = ref.finished, reset = ref.reset, resetTimer = ref.resetTimer, setErrors = ref.setErrors, started = ref.started, success = ref.success, updateAddress = ref.updateAddress;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Address Updated" : "Failed";
        }
        return started ? "Updating Address" : "Update Address";
    }, [
        started,
        success,
        finished
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm, {
        buttonText: buttonText,
        closeForm: function() {
            return setInitialAddress(null);
        },
        defaultAddress: defaultAddress,
        errors: errors,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var form, isDefault;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            form = param.form, isDefault = param.isDefault;
                            if (!form.country) {
                                setErrors([
                                    "Missing country"
                                ]);
                                return [
                                    2
                                ];
                            }
                            if (!form.province) {
                                setErrors([
                                    "Missing state/province"
                                ]);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                updateAddress({
                                    address: form,
                                    id: initialAddress === null || initialAddress === void 0 ? void 0 : initialAddress.id,
                                    isDefault: isDefault
                                })
                            ];
                        case 1:
                            _state.sent();
                            setInitialAddress(null);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        initialAddress: initialAddress,
        started: started,
        title: "Edit Address"
    });
}
EditAddressForm.displayname = "EditAddressForm";

;// CONCATENATED MODULE: ./src/templates/account/address-book/address-book.jsx












function AddressBook() {
    var ref, ref1, ref2, ref3;
    var _ref = (0,dist.useCustomerAddresses)(), addresses = _ref.addresses, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "addresses"
    ]);
    var defaultAddress = (0,dist.useCustomerDefaultAddress)();
    var asPath = (0,router.useRouter)().asPath;
    var settings = (0,dist.useSettings)();
    var ref4 = (0,react.useState)(null), initialAddress = ref4[0], setInitialAddress = ref4[1];
    var ref5 = (0,react.useState)(false), isCreateAddress = ref5[0], setIsCreateAddress = ref5[1];
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    var heading = (ref1 = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(param) {
        var link = param.link;
        return asPath.startsWith(link === null || link === void 0 ? void 0 : link.url);
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.link) === null || ref2 === void 0 ? void 0 : ref2.text;
    var defaultAddressId = defaultAddress === null || defaultAddress === void 0 ? void 0 : (ref3 = defaultAddress.id) === null || ref3 === void 0 ? void 0 : ref3.split("?")[0];
    var addressesWithDefaultFirst = addresses === null || addresses === void 0 ? void 0 : addresses.reduce(function(acc, address) {
        var ref;
        var isDefault = ((ref = address.id) === null || ref === void 0 ? void 0 : ref.split("?")[0]) === defaultAddressId;
        return isDefault ? [
            address
        ].concat((0,_to_consumable_array/* default */.Z)(acc)) : (0,_to_consumable_array/* default */.Z)(acc).concat([
            address
        ]);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_AccountLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-8 md:gap-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start justify-start gap-4 md:flex-row md:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-title-h4",
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": "Add a new address",
                            className: "text-main-underline text-nav bg-[linear-gradient(var(--primary),var(--primary))] font-normal",
                            onClick: function() {
                                setIsCreateAddress(true);
                                setInitialAddress(null);
                            },
                            type: "button",
                            children: "+ Add A New Address"
                        })
                    ]
                }),
                initialAddress && !isCreateAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditAddressForm, {
                    defaultAddress: defaultAddress,
                    initialAddress: initialAddress,
                    setInitialAddress: setInitialAddress
                }),
                isCreateAddress && !initialAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAddressForm, {
                    setIsCreateAddress: setIsCreateAddress
                }),
                status.started && !status.finished && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex min-h-[12rem] items-center justify-center text-mediumGray",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                        width: "32"
                    })
                }),
                status.finished && !(addressesWithDefaultFirst === null || addressesWithDefaultFirst === void 0 ? void 0 : addressesWithDefaultFirst.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "status",
                    className: "relative flex min-h-[12rem] items-center justify-center",
                    children: "You don't have any addresses saved yet"
                }),
                status.finished && !!(addressesWithDefaultFirst === null || addressesWithDefaultFirst === void 0 ? void 0 : addressesWithDefaultFirst.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "grid grid-cols-1 gap-6 md:grid-cols-2",
                    children: addressesWithDefaultFirst.map(function(address) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressBookItem, {
                                address: address,
                                defaultAddress: defaultAddress,
                                initialAddress: initialAddress,
                                setIsCreateAddress: setIsCreateAddress,
                                setInitialAddress: setInitialAddress
                            })
                        }, address.id);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/address-book/index.js


;// CONCATENATED MODULE: ./src/templates/account/edit-profile.jsx









function EditProfile(param) {
    var customer = param.customer;
    var ref, ref1, ref2;
    var ref3 = (0,dist.useCustomerUpdateDetails)(), customerUpdateDetails = ref3.customerUpdateDetails, started = ref3.started, finished = ref3.finished, errors = ref3.errors, success = ref3.success, reset = ref3.reset, resetTimer = ref3.resetTimer;
    var asPath = (0,router.useRouter)().asPath;
    var settings = (0,dist.useSettings)();
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    var heading = (ref1 = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(param) {
        var link = param.link;
        return asPath.startsWith(link === null || link === void 0 ? void 0 : link.url);
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.link) === null || ref2 === void 0 ? void 0 : ref2.text;
    var ref4 = (0,react.useState)(""), firstName = ref4[0], setFirstName = ref4[1];
    var ref5 = (0,react.useState)(""), lastName = ref5[0], setLastName = ref5[1];
    (0,react.useEffect)(function() {
        if (!customer) return;
        setFirstName(customer.firstName);
        setLastName(customer.lastName);
    }, [
        customer,
        finished
    ]);
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Saved" : "Failed";
        }
        return started ? "Saving" : "Save";
    }, [
        started,
        success,
        finished
    ]);
    var handleUpdateCustomerDetails = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!customer || started) return [
                            2
                        ];
                        return [
                            4,
                            customerUpdateDetails({
                                acceptsMarketing: customer.acceptsMarketing,
                                email: customer.email,
                                firstName: firstName,
                                lastName: lastName
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        firstName,
        lastName,
        started,
        customer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_AccountLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-title-h4 mb-8 md:mb-10",
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "grid grid-cols-2 gap-3 rounded border border-border p-4 sm:p-6",
                    onSubmit: handleUpdateCustomerDetails,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "firstName",
                            className: "col-span-2 sm:col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "input-label",
                                    children: "First Name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "input-text",
                                    name: "firstName",
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setFirstName(target.value);
                                    },
                                    placeholder: "First Name",
                                    required: true,
                                    type: "text",
                                    value: firstName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "lastName",
                            className: "col-span-2 sm:col-span-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "input-label",
                                    children: "Last Name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "input-text",
                                    name: "lastName",
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setLastName(target.value);
                                    },
                                    placeholder: "Last Name",
                                    required: true,
                                    type: "text",
                                    value: lastName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "email",
                            className: "col-span-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "input-label",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "input-text text-mediumGray",
                                    disabled: true,
                                    name: "email",
                                    placeholder: "Email",
                                    required: true,
                                    type: "email",
                                    value: customer === null || customer === void 0 ? void 0 : customer.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-2 flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Save to update profile",
                                className: "btn-primary mt-4 w-full min-w-[10rem] md:w-auto ".concat(started ? "cursor-default" : ""),
                                type: "submit",
                                children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                                    width: "20"
                                }) : buttonText
                            })
                        }),
                        (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "col-span-2 mt-4 flex flex-col items-center gap-1",
                            children: errors.map(function(error, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "text-center text-sm text-red-500",
                                    children: error
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/login/ForgotPasswordForm.jsx







function ForgotPasswordForm(param) {
    var setIsForgotPassword = param.setIsForgotPassword;
    var ref;
    var ref1 = (0,dist.useCustomerRecoverPassword)(), finished = ref1.finished, recoverPassword = ref1.recoverPassword, reset = ref1.reset, resetTimer = ref1.resetTimer, started = ref1.started, success = ref1.success;
    var settings = (0,dist.useSettings)();
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.forgot), heading = ref3.heading, postSubmissionText = ref3.postSubmissionText, subtext = ref3.subtext;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Submitted" : "Submitted";
        }
        return started ? "Submitting" : "Submit";
    }, [
        finished,
        started,
        success
    ]);
    var handleRecoverPassword = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var email;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        email = event.target.email;
                        return [
                            4,
                            recoverPassword({
                                email: email.value
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (finished) {
            setMessage(postSubmissionText);
            setTimeout(function() {
                setMessage("");
                setIsForgotPassword(false);
            }, 3000);
        }
    }, [
        finished
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center rounded border border-border px-3 py-6 md:px-6 md:py-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6 flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-title-h3 text-center",
                        children: heading
                    }),
                    subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "max-w-[20rem] text-center text-sm",
                        children: subtext
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto flex w-full max-w-[25rem] flex-col gap-4",
                onSubmit: handleRecoverPassword,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "email",
                                placeholder: "email@email.com",
                                required: true,
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Submit email for password recovery",
                        className: "btn-primary mt-3 min-w-[10rem] self-center ".concat(started ? "cursor-default" : ""),
                        type: "submit",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                            width: "20"
                        }) : buttonText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Cancel",
                className: "text-underline mt-4 text-center text-sm font-bold",
                onClick: function() {
                    return setIsForgotPassword(false);
                },
                type: "button",
                children: "Cancel"
            }),
            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 text-center text-sm",
                children: message
            })
        ]
    });
}
ForgotPasswordForm.displayName = "ForgotPasswordForm";

;// CONCATENATED MODULE: ./src/templates/account/login/LoginForm.jsx









function LoginForm(param) {
    var setIsForgotPassword = param.setIsForgotPassword;
    var ref;
    var ref1 = (0,dist.useCustomerLogin)(), customerLogin = ref1.customerLogin, started = ref1.started, finished = ref1.finished, errors = ref1.errors, success = ref1.success, reset = ref1.reset, resetTimer = ref1.resetTimer;
    var settings = (0,dist.useSettings)();
    var route = (0,router.useRouter)().route;
    var sendLogInEvent = (0,hooks/* useDataLayerActions */.KZ)().sendLogInEvent;
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.login), forgotText = ref2.forgotText, heading = ref2.heading, pageHeading = ref2.pageHeading, unidentifiedCustomerText = ref2.unidentifiedCustomerText;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Logged In" : "Failed";
        }
        return started ? "Logging In" : "Log In";
    }, [
        started,
        success,
        finished
    ]);
    var handleLogin = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _target, email, password;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (started) return [
                            2
                        ];
                        _target = event.target, email = _target.email, password = _target.password;
                        return [
                            4,
                            customerLogin({
                                email: email.value,
                                password: password.value
                            })
                        ];
                    case 1:
                        _state.sent();
                        sendLogInEvent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        started
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center rounded border border-border px-3 py-6 md:px-6 md:py-10",
        children: [
            route === "/account/login" && !pageHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-title-h3 mb-6 text-center",
                children: heading
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h3 mb-6 text-center",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto flex w-full max-w-[25rem] flex-col gap-4",
                onSubmit: handleLogin,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "email",
                                placeholder: "email@email.com",
                                required: true,
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "password",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "password",
                                placeholder: "••••••••",
                                required: true,
                                type: "password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Log in to your account",
                        className: "btn-primary mt-3 w-full min-w-[10rem] self-center md:w-auto ".concat(started ? "cursor-default" : ""),
                        type: "submit",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                            width: "20"
                        }) : buttonText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": forgotText,
                className: "text-underline mt-4 text-center text-sm font-bold",
                onClick: function() {
                    return setIsForgotPassword(true);
                },
                type: "button",
                children: forgotText
            }),
            (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-4 flex flex-col items-center gap-1",
                children: errors.map(function(error, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-center text-sm text-red-500",
                        children: error === "Unidentified customer" ? unidentifiedCustomerText : error
                    }, index);
                })
            })
        ]
    });
}
LoginForm.displayName = "LoginForm";

;// CONCATENATED MODULE: ./src/templates/account/register/RegisterForm.jsx









function RegisterForm() {
    var ref;
    var ref1 = (0,dist.useCustomerCreate)(), customerCreate = ref1.customerCreate, errors = ref1.errors, finished = ref1.finished, reset = ref1.reset, resetTimer = ref1.resetTimer, setErrors = ref1.setErrors, started = ref1.started, success = ref1.success;
    var settings = (0,dist.useSettings)();
    var route = (0,router.useRouter)().route;
    var sendRegisterEvent = (0,hooks/* useDataLayerActions */.KZ)().sendRegisterEvent;
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.register), heading = ref2.heading, pageHeading = ref2.pageHeading;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Account Created" : "Failed";
        }
        return started ? "Creating Account" : "Create Account";
    }, [
        finished,
        started,
        success
    ]);
    var handleCustomerCreate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _target, firstName, lastName, email, password, passwordConfirm;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (started) return [
                            2
                        ];
                        _target = event.target, firstName = _target.firstName, lastName = _target.lastName, email = _target.email, password = _target.password, passwordConfirm = _target.passwordConfirm;
                        if (password.value !== passwordConfirm.value) {
                            setErrors([
                                "Passwords do not match. Please try again."
                            ]);
                            if (finished) {
                                resetTimer.current = setTimeout(function() {
                                    if (reset) reset();
                                    clearTimeout(resetTimer.current);
                                }, 3000);
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            customerCreate({
                                firstName: firstName.value,
                                lastName: lastName.value,
                                email: email.value,
                                password: password.value,
                                acceptsMarketing: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        sendRegisterEvent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        finished,
        reset,
        started
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded border border-border px-3 py-6 md:px-6 md:py-10",
        children: [
            route === "/account/register" && !pageHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-title-h3 mb-6 text-center",
                children: heading
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h3 mb-6 text-center",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto flex w-full max-w-[25rem] flex-col gap-4",
                onSubmit: handleCustomerCreate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "firstName",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "First Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "firstName",
                                placeholder: "First Name",
                                required: true,
                                type: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lastName",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Last Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "lastName",
                                placeholder: "Last Name",
                                required: true,
                                type: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "email",
                                placeholder: "email@email.com",
                                required: true,
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "password",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "password",
                                placeholder: "••••••••",
                                required: true,
                                type: "password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "passwordConfirm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "input-label",
                                children: "Confirm Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "input-text",
                                name: "passwordConfirm",
                                placeholder: "••••••••",
                                required: true,
                                type: "password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Create Account",
                        className: "btn-primary mt-3 w-full min-w-[10rem] self-center md:w-auto  ".concat(started ? "cursor-default" : ""),
                        type: "submit",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                            width: "20"
                        }) : buttonText
                    })
                ]
            }),
            (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-4 flex flex-col items-center gap-1",
                children: errors.map(function(error, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-center text-sm text-red-500",
                        children: error
                    }, index);
                })
            })
        ]
    });
}
RegisterForm.displayName = "RegisterForm";

;// CONCATENATED MODULE: ./src/templates/account/login/login.jsx









function Login() {
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.login), createLinkText = ref1.createLinkText, createText = ref1.createText, heading = ref1.heading, pageHeading = ref1.pageHeading;
    var ref2 = (0,react.useState)(false), isForgotPassword = ref2[0], setIsForgotPassword = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        heading,
                         true ? " | ".concat("Storefront Starter") : 0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained py-contained flex flex-col items-center",
                children: [
                    pageHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-title-h2 mb-6",
                        children: pageHeading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto grid w-full max-w-[28rem] grid-cols-1 gap-5 md:max-w-[64rem] md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: isForgotPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm, {
                                    setIsForgotPassword: setIsForgotPassword
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                                    setIsForgotPassword: setIsForgotPassword
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex flex-wrap justify-center gap-x-1.5 md:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: createText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": "Create account",
                                className: "text-underline font-bold",
                                href: "/account/register",
                                children: createLinkText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
Login.displayName = "Login";

;// CONCATENATED MODULE: ./src/templates/account/login/index.js


;// CONCATENATED MODULE: ./src/templates/account/order/OrderAddressAndStatus.jsx



function OrderAddressAndStatus(param) {
    var order = param.order;
    var ref, ref1, ref2, ref3;
    var financialStatus = order.financialStatus, fulfillmentStatus = order.fulfillmentStatus, shippingAddress = order.shippingAddress, statusUrl = order.statusUrl;
    var ref4 = (0,_object_spread/* default */.Z)({}, shippingAddress), address1 = ref4.address1, address2 = ref4.address2, city = ref4.city, company = ref4.company, country = ref4.country, name = ref4.name, phone = ref4.phone, provinceCode = ref4.provinceCode, zip = ref4.zip;
    var shippingUrl = (ref = order.successfulFulfillments) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.trackingInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-5 flex flex-wrap gap-y-8 gap-x-20 md:mt-10 lg:gap-36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "text-label mb-3",
                        children: "Shipping Address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1.5 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: name
                            }),
                            company && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: company
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address1
                            }),
                            address2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "".concat(city, ", ").concat(provinceCode, " ").concat(zip)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: country
                            }),
                            phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: phone
                            }),
                            shippingUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": "Go to shipping tracking page",
                                href: shippingUrl,
                                newTab: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-label text-main-underline bg-[linear-gradient(var(--primary),var(--primary))]",
                                    children: "Track Shipping"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "text-label mb-3",
                        children: "Status"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1.5 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Payment: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold",
                                        children: financialStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Fulfillment: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold",
                                        children: fulfillmentStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": "Go to order tracking page",
                                href: statusUrl,
                                newTab: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-label text-main-underline bg-[linear-gradient(var(--primary),var(--primary))]",
                                    children: "Track Order"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
OrderAddressAndStatus.displayName = "OrderAddressAndStatus";

;// CONCATENATED MODULE: ./src/templates/account/order/OrderItem.jsx



function OrderItem(param) {
    var item = param.item;
    var ref, ref1, ref2, ref3;
    var discountedTotalPrice = item.discountedTotalPrice, originalTotalPrice = item.originalTotalPrice, quantity = item.quantity, variant = item.variant;
    var prices = (0,react.useMemo)(function() {
        var discountedFloat = parseFloat(discountedTotalPrice === null || discountedTotalPrice === void 0 ? void 0 : discountedTotalPrice.amount);
        var originalFloat = parseFloat(originalTotalPrice === null || originalTotalPrice === void 0 ? void 0 : originalTotalPrice.amount);
        var isDiscounted = discountedFloat < originalFloat;
        var formatPrice = function(price) {
            return "$".concat(price.toFixed(2));
        };
        return {
            originalPrice: formatPrice(originalFloat / quantity),
            discountedPrice: isDiscounted ? formatPrice(discountedFloat / quantity) : null,
            originalTotal: formatPrice(originalFloat),
            discountedTotal: isDiscounted ? formatPrice(discountedFloat) : null
        };
    }, [
        discountedTotalPrice === null || discountedTotalPrice === void 0 ? void 0 : discountedTotalPrice.amount,
        originalTotalPrice === null || originalTotalPrice === void 0 ? void 0 : originalTotalPrice.amount,
        quantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-[10fr_auto] items-center gap-3 border-b border-b-border py-4 text-sm md:grid-cols-[6fr_2fr_1fr_1fr_1fr]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-[3rem_1fr] items-center gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-offWhite",
                        style: {
                            aspectRatio: (variant === null || variant === void 0 ? void 0 : (ref = variant.image) === null || ref === void 0 ? void 0 : ref.width) && (variant === null || variant === void 0 ? void 0 : (ref1 = variant.image) === null || ref1 === void 0 ? void 0 : ref1.height) ? variant.image.width / variant.image.height : "var(--product-image-aspect-ratio)"
                        },
                        children: (variant === null || variant === void 0 ? void 0 : (ref2 = variant.image) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            alt: (ref3 = variant.product) === null || ref3 === void 0 ? void 0 : ref3.title,
                            height: Math.floor(48 / (variant.image.width / variant.image.height)),
                            src: variant.image.src,
                            width: "48"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 flex-col items-start gap-2",
                        children: [
                            (variant === null || variant === void 0 ? void 0 : variant.product) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": variant.product.title,
                                href: "/products/".concat(variant.product.handle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "break-words font-semibold",
                                    children: variant.product.title
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "break-words font-semibold",
                                children: item.title
                            }),
                            (variant === null || variant === void 0 ? void 0 : variant.title) !== "Default Title" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xss md:hidden",
                                children: variant === null || variant === void 0 ? void 0 : variant.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-1 text-xs md:hidden",
                                children: [
                                    prices.discountedTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-mediumGray line-through",
                                        children: prices.discountedTotal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: prices.originalPrice
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "x ",
                                            quantity
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "hidden md:block",
                children: (variant === null || variant === void 0 ? void 0 : variant.title) !== "Default Title" ? "" : variant === null || variant === void 0 ? void 0 : variant.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden md:block",
                children: [
                    prices.discountedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-mediumGray line-through",
                        children: prices.discountedPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: prices.originalPrice
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "hidden md:block",
                children: quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    prices.discountedTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-mediumGray line-through",
                        children: prices.discountedTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: prices.originalTotal
                    })
                ]
            })
        ]
    });
}
OrderItem.displayName = "OrderItem";

;// CONCATENATED MODULE: ./src/templates/account/order/OrderItems.jsx


function OrderItems(param) {
    var order = param.order;
    var ref;
    var mobileHeaders = [
        "Product",
        "Total"
    ];
    var headers = [
        "Product",
        "Title",
        "Price",
        "Qty",
        "Total"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-[10fr_auto] gap-3 md:hidden",
                children: mobileHeaders.map(function(header) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "text-label",
                        children: header
                    }, header);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden grid-cols-[6fr_2fr_1fr_1fr_1fr] gap-3 md:grid",
                children: headers.map(function(header) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "text-label",
                        children: header
                    }, header);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem, {
                            item: item
                        })
                    }, index);
                })
            })
        ]
    });
}
OrderItems.displayName = "OrderItems";

;// CONCATENATED MODULE: ./src/templates/account/order/OrderTotals.jsx



var formatAmount = function(amount) {
    if (!amount && amount !== 0) return null;
    return "$".concat((amount === "number" ? amount : parseFloat(amount)).toFixed(2));
};
function OrderTotals(param) {
    var order = param.order;
    var totals = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var subtotalAmount = (ref = order.subtotalPriceV2) === null || ref === void 0 ? void 0 : ref.amount;
        var discountAmount;
        if (((ref1 = order.discountApplications) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.targetType) === "LINE_ITEM") {
            var subtotal = 0;
            var discountTotal = 0;
            order.lineItems.forEach(function(item) {
                var ref, ref1, ref2, ref3;
                subtotal += parseFloat(((ref = item.discountedTotalPrice) === null || ref === void 0 ? void 0 : ref.amount) || ((ref1 = item.originalTotalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0");
                discountTotal += parseFloat(((ref2 = item.discountAllocations) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.allocatedAmount.amount) || "0");
            });
            subtotalAmount = subtotal;
            discountAmount = discountTotal;
        }
        return [
            {
                label: "Subtotal",
                amount: formatAmount(subtotalAmount)
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(discountAmount ? [
            {
                label: "Discount",
                amount: "-".concat(formatAmount(discountAmount))
            }, 
        ] : []), [
            {
                label: "Shipping",
                amount: formatAmount((ref3 = order.totalShippingPriceV2) === null || ref3 === void 0 ? void 0 : ref3.amount)
            },
            {
                label: "Tax",
                amount: formatAmount((ref4 = order.totalTaxV2) === null || ref4 === void 0 ? void 0 : ref4.amount)
            },
            {
                label: "Total",
                amount: formatAmount((ref5 = order.totalPriceV2) === null || ref5 === void 0 ? void 0 : ref5.amount)
            }, 
        ], (0,_to_consumable_array/* default */.Z)(parseFloat((ref6 = order.totalRefundedV2) === null || ref6 === void 0 ? void 0 : ref6.amount) > 0 ? [
            {
                label: "Refunded",
                amount: "-".concat(formatAmount(order.totalRefundedV2.amount))
            }, 
        ] : []));
    }, [
        order.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: totals.map(function(param) {
            var label = param.label, amount = param.amount;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-[10fr_auto] items-center gap-3 border-b border-b-border py-5 last:border-none md:grid-cols-[10fr_1fr] md:gap-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-label",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat(label === "Total" ? "text-lg font-bold" : "text-sm"),
                        children: amount
                    })
                ]
            }, label);
        })
    });
}
OrderTotals.displayName = "OrderTotals";

;// CONCATENATED MODULE: ./src/templates/account/order/order.jsx









function Order() {
    var query = (0,router.useRouter)().query;
    var ref = (0,dist.useCustomerOrder)({
        id: query.id
    }), finished = ref.finished, order = ref.order, started = ref.started;
    var orderDate = (0,react.useMemo)(function() {
        if (!(order === null || order === void 0 ? void 0 : order.processedAt)) return null;
        var date = new Date(order.processedAt);
        return date.toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    }, [
        order === null || order === void 0 ? void 0 : order.processedAt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_AccountLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": "Go back to order history page",
                            className: "mt-1 w-5 md:mt-1 lg:mt-1.5",
                            href: "/account/orders",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                src: "/svgs/arrow-left.svg#arrow-left",
                                title: "Arrow Left",
                                viewBox: "0 0 24 24"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 flex-col items-start gap-x-4 gap-y-1 md:flex-row md:items-center md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "text-title-h4 md:text-title-h5 lg:text-title-h4",
                                    children: [
                                        "Order ",
                                        order === null || order === void 0 ? void 0 : order.name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm md:text-right",
                                    children: orderDate
                                })
                            ]
                        })
                    ]
                }),
                started && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex min-h-[12rem] items-center justify-center text-mediumGray",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                        width: "32"
                    })
                }),
                finished && !order && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex min-h-[12rem] items-center justify-center",
                    role: "status",
                    children: "Order not found."
                }),
                finished && order && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItems, {
                            order: order
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTotals, {
                            order: order
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderAddressAndStatus, {
                            order: order
                        })
                    ]
                })
            ]
        })
    });
}
Order.displayName = "OrderDetails";

;// CONCATENATED MODULE: ./src/templates/account/order/index.js


// EXTERNAL MODULE: ../node_modules/lodash.startcase/index.js
var lodash_startcase = __webpack_require__(8372);
var lodash_startcase_default = /*#__PURE__*/__webpack_require__.n(lodash_startcase);
;// CONCATENATED MODULE: ./src/templates/account/orders/OrdersItem.jsx




function OrdersItem(param) {
    var order = param.order;
    var orderDate = (0,react.useMemo)(function() {
        var newDate = new Date(order.processedAt);
        return newDate.toLocaleDateString("default", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    }, [
        order.processedAt
    ]);
    var orders = (0,react.useMemo)(function() {
        return order.lineItems.edges.map(function(param) {
            var node = param.node;
            return node.title;
        }).join(", ");
    }, [
        order.id
    ]);
    var financialStatus = lodash_startcase_default()(order.financialStatus.toLowerCase());
    var fulfillmentStatus = lodash_startcase_default()(order.fulfillmentStatus.toLowerCase());
    var total = "$".concat(parseFloat(order.totalPriceV2.amount).toFixed(2));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-3 rounded border border-border p-6 md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": "Go to order page for order ".concat(order.name),
                                href: order.detailsUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-main-underline text-nav bg-[linear-gradient(var(--primary),var(--primary))] text-right font-normal",
                                    children: [
                                        "Order ",
                                        order.name
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm",
                                children: orderDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-title-h4",
                        children: total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs",
                        children: orders
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-xs",
                        children: [
                            "Payment: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium",
                                children: financialStatus
                            }),
                            " / Fufillment: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium",
                                children: fulfillmentStatus
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden grid-cols-[2fr_2fr_2fr_2fr_1fr] gap-3 text-sm md:grid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": "Go to order page for order ".concat(order.name),
                            href: order.detailsUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-main-underline text-nav bg-[linear-gradient(var(--primary),var(--primary))] font-normal",
                                children: order.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: orderDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: financialStatus
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: fulfillmentStatus
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: total
                    })
                ]
            })
        ]
    });
}
OrdersItem.displayName = "OrdersItem";

;// CONCATENATED MODULE: ./src/templates/account/orders/orders.jsx








function Orders() {
    var ref, ref1, ref2, ref3;
    var settings = (0,dist.useSettings)();
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref1 = settings.account) === null || ref1 === void 0 ? void 0 : ref1.orders), buttonStyle = ref4.buttonStyle, emptyOrdersButton = ref4.emptyOrdersButton, emptyOrdersText = ref4.emptyOrdersText, ordersPerPage = ref4.ordersPerPage;
    var _ref = (0,dist.useCustomerOrders)({
        perPage: ordersPerPage || 10
    }), getNext = _ref.getNext, getPrevious = _ref.getPrevious, hasNext = _ref.hasNext, hasPrevious = _ref.hasPrevious, orders = _ref.orders, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "getNext",
        "getPrevious",
        "hasNext",
        "hasPrevious",
        "orders"
    ]);
    var asPath = (0,router.useRouter)().asPath;
    var heading = (ref2 = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(param) {
        var link = param.link;
        return asPath.startsWith(link === null || link === void 0 ? void 0 : link.url);
    })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.link) === null || ref3 === void 0 ? void 0 : ref3.text;
    var headers = [
        "Order",
        "Date",
        "Payment Status",
        "Fulfillment Status",
        "Total", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_AccountLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-8 md:gap-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-title-h4",
                    children: heading
                }),
                status.started && !status.finished && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex min-h-[12rem] items-center justify-center text-mediumGray",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                        width: "32"
                    })
                }),
                status.finished && !(orders === null || orders === void 0 ? void 0 : orders.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex min-h-[12rem] flex-col items-center justify-center gap-4",
                    role: "status",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center",
                            children: emptyOrdersText
                        }),
                        (emptyOrdersButton === null || emptyOrdersButton === void 0 ? void 0 : emptyOrdersButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            className: "".concat(buttonStyle),
                            href: emptyOrdersButton.url,
                            children: emptyOrdersButton.text
                        })
                    ]
                }),
                status.success && !!(orders === null || orders === void 0 ? void 0 : orders.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden grid-cols-[2fr_2fr_2fr_2fr_1fr] gap-3 md:grid",
                            children: headers.map(function(header) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "text-label",
                                    children: header
                                }, header);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col gap-3 md:gap-8",
                            children: orders.map(function(order) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrdersItem, {
                                        order: order
                                    })
                                }, order.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: hasPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-label": "See previous orders",
                                        className: "text-underline text-xs",
                                        onClick: function() {
                                            getPrevious();
                                            window.scrollTo({
                                                top: 0,
                                                behavior: "smooth"
                                            });
                                        },
                                        type: "button",
                                        children: "Previous"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: hasNext && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-label": "See next orders",
                                        className: "text-underline text-xs",
                                        onClick: function() {
                                            getNext();
                                            window.scrollTo({
                                                top: 0,
                                                behavior: "smooth"
                                            });
                                        },
                                        type: "button",
                                        children: "Next"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/orders/index.js


;// CONCATENATED MODULE: ./src/templates/account/register/register.jsx









function Register() {
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.register), heading = ref1.heading, pageHeading = ref1.pageHeading, loginText = ref1.loginText, loginLinkText = ref1.loginLinkText;
    var ref2 = (0,react.useState)(false), isForgotPassword = ref2[0], setIsForgotPassword = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        heading,
                         true ? " | ".concat("Storefront Starter") : 0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained py-contained flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-title-h2 mb-6",
                        children: pageHeading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto grid w-full max-w-[28rem] grid-cols-1 gap-5 md:max-w-[64rem] md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block",
                                children: isForgotPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm, {
                                    setIsForgotPassword: setIsForgotPassword
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                                    setIsForgotPassword: setIsForgotPassword
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex flex-wrap justify-center gap-x-1.5 md:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: loginText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": "Go to login page",
                                className: "text-underline font-bold",
                                href: "/account/login",
                                children: loginLinkText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
Register.displayName = "Register";

;// CONCATENATED MODULE: ./src/templates/account/register/index.js


;// CONCATENATED MODULE: ./src/templates/account/reset-password.jsx








function ResetPassword(param) {
    var params = param.params;
    var ref;
    var ref1 = (0,dist.useCustomerResetPassword)(), resetPassword = ref1.resetPassword, started = ref1.started, finished = ref1.finished, errors = ref1.errors, setErrors = ref1.setErrors, success = ref1.success, reset = ref1.reset, resetTimer = ref1.resetTimer;
    var router = (0,dist.useRouter)();
    var settings = (0,dist.useSettings)();
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.reset), heading = ref2.heading, subtext = ref2.subtext;
    var customerId = params.customerId, resetToken = params.resetToken;
    var resetUrl = "https://".concat("pack-sandbox-store-1.myshopify.com", "/account/reset/").concat(customerId, "/").concat(resetToken);
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Password Reset" : "Failed";
        }
        return started ? "Resetting Password" : "Reset Password";
    }, [
        started,
        success,
        finished
    ]);
    var handleResetPassword = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _target, password, passwordConfirm;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (started) return [
                            2
                        ];
                        _target = event.target, password = _target.password, passwordConfirm = _target.passwordConfirm;
                        if (password.value !== passwordConfirm.value) {
                            setErrors([
                                "Passwords do not match. Please try again."
                            ]);
                            if (finished) {
                                resetTimer.current = setTimeout(function() {
                                    if (reset) reset();
                                    clearTimeout(resetTimer.current);
                                }, 3000);
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            resetPassword({
                                password: password.value,
                                url: resetUrl
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        finished,
        reset,
        resetUrl,
        started
    ]);
    (0,react.useEffect)(function() {
        if (finished && success) {
            setTimeout(function() {
                return router.push("/account/login");
            }, 3000);
        }
    }, [
        finished,
        success
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        heading,
                         true ? " | ".concat("Storefront Starter") : 0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained py-contained flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto flex w-full max-w-[28rem] flex-col items-center rounded border border-border px-3 py-6 md:px-6 md:py-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-title-h3 text-center",
                                    children: heading
                                }),
                                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[20rem] text-center text-sm",
                                    children: subtext
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "mx-auto flex w-full max-w-[25rem] flex-col gap-4",
                            onSubmit: handleResetPassword,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "password",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-title-h6 block pb-1 pl-5",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "input-text",
                                            name: "password",
                                            placeholder: "••••••••",
                                            required: true,
                                            type: "password"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "passwordConfirm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-title-h6 block pb-1 pl-5",
                                            children: "Confirm Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "input-text",
                                            name: "passwordConfirm",
                                            placeholder: "••••••••",
                                            required: true,
                                            type: "password"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Submit to reset password",
                                    className: "btn-primary mt-3 min-w-[10rem] self-center ".concat(started ? "cursor-default" : ""),
                                    type: "submit",
                                    children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                                        width: "20"
                                    }) : buttonText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": "Go back to login page",
                            className: "text-underline mt-4 text-center text-sm font-bold",
                            href: "/account/login",
                            children: "Cancel"
                        }),
                        (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "mt-4 flex flex-col items-center gap-1",
                            children: errors.map(function(error, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "text-center text-sm text-red-500",
                                    children: error
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
ResetPassword.displayName = "ResetPassword";

;// CONCATENATED MODULE: ./src/templates/account/index.js








/* harmony default export */ var account = ({
    // logged out
    activate: Activate,
    login: Login,
    register: Register,
    "reset-password": ResetPassword,
    // logged in
    "address-book": AddressBook,
    "edit-profile": EditProfile,
    order: Order,
    orders: Orders
});


/***/ })

}]);